module.exports = __webpack_public_path__ + "static/media/Carousel Image 5.ff35d992.png";